import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

import { throttle } from 'lodash';

import { useLogout } from '@hooks/use-logout';
import { isLoggedInUser } from '@utils/auth';

import { interactionEvents, THROTTLE_DELAY } from './constants';

const SessionLogout = ({
  setShowFullLoader,
}: {
  setShowFullLoader: Dispatch<SetStateAction<boolean>>;
}) => {
  const { mutateAsync: logout } = useLogout();

  const handleLogout = () => {
    setShowFullLoader(true);
    logout();
  };

  const handleSessionLogout = () => {
    if (!isLoggedInUser()) {
      handleLogout();
    }
  };

  const handleThrottledSessionLogout = useRef(
    throttle(handleSessionLogout, THROTTLE_DELAY),
  ).current;

  useEffect(function checkInitialSessionLogout() {
    handleSessionLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    interactionEvents.forEach(event =>
      window.addEventListener(event, handleThrottledSessionLogout),
    );

    return () => {
      interactionEvents.forEach(event =>
        window.removeEventListener(event, handleThrottledSessionLogout),
      );
    };
  }, [handleThrottledSessionLogout]);

  return null;
};

export default SessionLogout;
